import React from 'react';
import { Box, Stack } from '@chakra-ui/react';

import { ProfileField } from '../elements/ProfileField';
import { ProfileSelect } from '../elements/ProfileSelect';
import { sponsor } from '../data';
import { makeFields } from './utils';

export const Sponsor = ({ state, setter, onBlur }) => {
	const {
		firstName,
		lastName,
		phoneNumber,
		email,
		birthDate,
		citizenship,
		residence,
		currentEmployment,
		canadaPresence,
		priorSponsorships,
		alimony,
		bancruptcy,
		stateSupport,
	} = makeFields(state, setter, sponsor, onBlur);

	return (
		<Box>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...firstName} />
				<ProfileField pb={6} {...lastName} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...phoneNumber} />
				<ProfileField pb={6} {...email} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...birthDate} />
				<ProfileSelect pb={6} {...citizenship} />
				<ProfileSelect pb={6} {...residence} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...currentEmployment} />
				<ProfileField pb={6} {...canadaPresence} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...priorSponsorships} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...alimony} />
				<ProfileField pb={6} {...bancruptcy} />
				<ProfileField pb={6} {...stateSupport} />
			</Stack>
		</Box>
	);
};
